/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Clear_TitleInputs */

const en_confirm_clear_title = /** @type {(inputs: Confirm_Clear_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

const ko_confirm_clear_title = /** @type {(inputs: Confirm_Clear_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초기화`)
};

const ja_confirm_clear_title = /** @type {(inputs: Confirm_Clear_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリア`)
};

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Confirm_Clear_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const confirm_clear_title = /** @type {((inputs?: Confirm_Clear_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Clear_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_clear_title(inputs)
	if (locale === "ko") return ko_confirm_clear_title(inputs)
	return ja_confirm_clear_title(inputs)
});